import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import Types from './types'
import Item from './item'
import React from 'react'

class Overview extends React.Component {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    code: PropTypes.string,
    criteria: PropTypes.array,
    defaultValue: PropTypes.object,
    fields: PropTypes.array,
    panel: PropTypes.object,
    standalone: PropTypes.bool,
    test: PropTypes.array,
    onAddItems: PropTypes.func,
    onChange: PropTypes.func,
    onClearTestItem: PropTypes.func,
    onMoveItem: PropTypes.func,
    onPop: PropTypes.func,
    onPush: PropTypes.func,
    onReorderItems: PropTypes.func,
    onRemoveItems: PropTypes.func,
    onSetItems: PropTypes.func,
    onSetTestItem: PropTypes.func
  }

  _handleAdd = this._handleAdd.bind(this)
  _handleCancel = this._handleCancel.bind(this)
  _handleCreate = this._handleCreate.bind(this)
  _handleMove = this._handleMove.bind(this)
  _handlePop = this._handlePop.bind(this)
  _handlePush = this._handlePush.bind(this)
  _handleReorder = this._handleReorder.bind(this)
  _handleTest = this._handleTest.bind(this)

  render() {
    const { criteria } = this.props
    return (
      <ModalPanel { ...this._getPanel() }>
        { criteria && criteria.length > 0 &&
          <div className="maha-criteria-overview">
            <div className="maha-criteria-overview-body">
              <div className="maha-criteria-items">
                <Item { ...this._getItem(criteria[0]) } />
              </div>
            </div>
          </div>
        }
      </ModalPanel>
    )
  }

  _getItem(criteria) {
    const { fields, onRemoveItems } = this.props
    return {
      criteria,
      fields,
      onAdd: this._handleAdd,
      onMove: this._handleMove,
      onReorder: this._handleReorder,
      onRemove: onRemoveItems
    }
  }

  _getPanel() {
    const { panel } = this.props
    return {
      ...panel,
      showHeader: panel !== undefined
    }
  }

  _getTypes(parent) {
    const { fields } = this.props
    return {
      parent,
      types: fields,
      onCancel: this._handleCancel,
      onChange: this._handleTest,
      onDone: this._handleCreate,
      onPop: this._handlePop,
      onPush: this._handlePush
    }
  }

  _handleAdd(parent) {
    this._handlePush(Types, this._getTypes(parent))
  }

  _handleCancel() {
    this.props.onClearTestItem()
    this._handlePop()
  }

  _handleCreate(value, index = -2) {
    this.props.onAddItems(value)
    this._handlePop(index)
  }

  _handleMove(sourceCode, targetParent, targetIndex = null) {
    this.props.onMoveItem(sourceCode, targetParent, targetIndex)
  }

  _handleReorder(sourceCode, targetCode, parentCode) {
    this.props.onReorderItems(sourceCode, targetCode, parentCode)
  }

  _handleTest(value) {
    this.props.onSetTestItem(value)
  }

  _handlePop(index = -1) {
    const { standalone, onPop } = this.props
    const { form } = this.context
    if(standalone) return onPop(index)
    form.pop(index)
  }

  _handlePush(component, props) {
    const { standalone, onPush } = this.props
    const { form } = this.context
    if(standalone) return onPush(component, props)
    form.push(component, props)
  }

}

export default Overview
